import type { RouteRecordRaw } from "vue-router";
import Register from "./pages/Register.vue";
import FinishRegistration from "./pages/FinishRegistration.vue";
import ForgotPassword from "./pages/ForgotPassword.vue";
import ResetPassword from "./pages/ResetPassword.vue";

export const publicRoutes: RouteRecordRaw[] = [
  {
    path: "/register",
    name: "register",
    component: Register,
    meta: { guestOnly: true, title: "auth.register_page_title" },
  },
  {
      path: "/finish-registration",
      name: "verify-email",
      component: FinishRegistration,
      meta: { guestOnly: true, title: "auth.finish_registration_title" },
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: ForgotPassword,
    meta: { guestOnly: true, title: "auth.recover_page_title" },
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: ResetPassword,
    meta: { guestOnly: true, title: "auth.reset_page_title" },
  }
];
